module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Edition du formulaire Conformité","titleForm":"Conformité - Dossier N°{folderNumber}","submit":"Enregistrer","submitForValidation":"Enregistrer pour validation","cancel":"Retour","processing":"Traitement en cours..."}}')
  delete Component.options._Ctor
}
